export const SET_RECEIPT_SETTINGS_DATA_LOADING = "SET_RECEIPT_SETTINGS_DATA_LOADING";
export const SET_RECEIPT_SETTINGS_DATA = "SET_RECEIPT_SETTINGS_DATA";
export const CLEAR_RECEIPT_SETTINGS_DATA = "CLEAR_RECEIPT_SETTINGS_DATA";